import clsx from 'clsx';
import { EdiPurchaseOrderStatusEnum } from '@/api/hanly-v2/hanlyAPIV2.schemas';

export const statusLabels: Record<EdiPurchaseOrderStatusEnum, string> = {
  PENDING: '未確定',
  CONFIRMED: '確定済',
};

export const StatusBadge = ({
  status,
  className,
}: {
  status: EdiPurchaseOrderStatusEnum;
  className?: string;
}) => (
  <span
    className={clsx(
      'inline-block px-2 py-0.5 text-sm font-bold whitespace-nowrap',
      status === EdiPurchaseOrderStatusEnum.PENDING && 'bg-[#FFD230] text-zinc-800',
      status === EdiPurchaseOrderStatusEnum.CONFIRMED && 'bg-[#00873A] text-white',
      className,
    )}
  >
    {statusLabels[status] ?? status}
  </span>
);
